import React, { useState, useEffect } from 'react';
import { BookOpen, Plus, Trash2, Settings } from 'lucide-react';

const CourseList = ({
  courses,
  onAddCourse,
  onRemoveCourse,
  onShowCourseDetails,
  onShowBatchModal
}) => {
  const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0, courseName: '' });

  const handleCourseRightClick = (e, courseName) => {
    e.preventDefault();
    setContextMenu({
      show: true,
      x: e.clientX,
      y: e.clientY,
      courseName: courseName
    });
  };

  const handleDeleteCourse = () => {
    if (contextMenu.courseName && onRemoveCourse) {
      onRemoveCourse(contextMenu.courseName);
    }
    setContextMenu({ show: false, x: 0, y: 0, courseName: '' });
  };

  const handleContextMenuClose = () => {
    setContextMenu({ show: false, x: 0, y: 0, courseName: '' });
  };

  // 点击外部关闭右键菜单
  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu.show) {
        setContextMenu({ show: false, x: 0, y: 0, courseName: '' });
      }
    };

    if (contextMenu.show) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [contextMenu.show]);
  const handleDragStart = (e, courseName) => {
    e.dataTransfer.setData('text/plain', courseName);
  };

  return (
    <div className="sidebar-card">
      <h4 className="section-title">课程列表</h4>
      <div id="course-list" className="flex flex-col gap-2 mb-4">
        {courses.map((course, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => handleDragStart(e, course.name)}
            onContextMenu={(e) => handleCourseRightClick(e, course.name)}
            data-course={course.name}
            data-color={course.color}
            className="course-item cursor-pointer hover:bg-red-50 transition-colors duration-200"
            style={{ borderLeft: `5px solid ${course.color}` }}
            title="右键删除此课程"
          >
            {course.name}
          </div>
        ))}
      </div>
      
      <div className="flex flex-col gap-2">
        <button className="btn btn-success" onClick={onAddCourse}>
          <Plus size={16} className="mr-2" />
          添加课程
        </button>
        <button className="btn btn-primary" onClick={onShowCourseDetails}>
          <Settings size={16} className="mr-2" />
          课程详情
        </button>
        <button className="btn btn-warning" onClick={onShowBatchModal}>
          <BookOpen size={16} className="mr-2" />
          批量管理
        </button>
      </div>
      
      {/* 右键菜单 */}
      {contextMenu.show && (
        <div
          className="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1 min-w-[120px]"
          style={{
            left: contextMenu.x,
            top: contextMenu.y,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="w-full px-4 py-2 text-left text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors duration-200"
            onClick={handleDeleteCourse}
          >
            <Trash2 size={16} />
            删除课程
          </button>
        </div>
      )}
    </div>
  );
};

export default CourseList;
